import React, { useMemo } from 'react';
import styled from 'styled-components';
import { CpWidgetDidiverProps } from './cp-widget-divider';

const Wrapper = styled.div<{
  height?: string;
}>`
  bottom: 0;
  left: 0;
  width: 100%;
  --cp-divider-height: ${({ height }) => height};
`;

const BackgroundWrapper = styled.div<{ bg?: string; height: string }>`
  background: ${({ bg }) => bg || 'transparent'};
  height: calc(var(--cp-divider-height) / 2 * var(--cp-divider-height));
`;

const RoundedRectangle = styled.div<{ bg?: string; height?: string }>`
  border-radius: 0 0 var(--cp-divider-height) var(--cp-divider-height);
  background: ${({ bg }) => bg || 'transparent'};
  height: ${({ height }) => height || '100rem'};
`;

const InvertedBackgroundWrapper = styled.div<{ bg?: string; height: string }>`
  background: ${({ bg }) => bg || 'white'};
  height: calc(var(--cp-divider-height) / 2 * var(--cp-divider-height));
`;

const InvertedRoundedRectangle = styled.div<{ bg?: string; height?: string }>`
  border-radius: var(--cp-divider-height) var(--cp-divider-height) 0 0;
  background: ${({ bg }) => bg || 'white'};
  height: ${({ height }) => height || '100rem'};
`;

export const CpRoundedRectangleWidgetDivider: React.FC<CpWidgetDidiverProps> =
  ({ widget, nextWidget }) => {
    const backgroundForBackgroundWrapper = useMemo(
      () =>
        nextWidget?.widgetDefinition?.styles?.background as string | undefined,
      [nextWidget?.widgetDefinition?.styles?.background],
    );
    const backgroundForRoundedRectangle = useMemo(
      () => widget?.widgetDefinition?.styles?.background as string | undefined,
      [widget?.widgetDefinition?.styles?.background],
    );

    const height = useMemo(() => {
      return (`${widget.widgetDefinition?.styles?.height ?? 50}px` ??
        '50px') as string;
    }, [widget.widgetDefinition?.styles?.height]);

    const isFlipped = widget.widgetDefinition?.styles?.isFlip ?? false;
    const isDividerEnabled =
      widget.widgetDefinition?.styles?.isDividerEnabled ?? false;

    return (
      isDividerEnabled && (
        <>
          {isFlipped ? (
            <Wrapper height={height}>
              <InvertedBackgroundWrapper
                bg={backgroundForRoundedRectangle}
                height={height ?? '50px'}
              >
                <InvertedRoundedRectangle
                  bg={backgroundForBackgroundWrapper}
                  height={height ?? '50px'}
                />
              </InvertedBackgroundWrapper>
            </Wrapper>
          ) : (
            <Wrapper height={height}>
              <BackgroundWrapper
                bg={backgroundForBackgroundWrapper}
                height={height ?? '50px'}
              >
                <RoundedRectangle
                  bg={backgroundForRoundedRectangle}
                  height={height ?? '50px'}
                />
              </BackgroundWrapper>
            </Wrapper>
          )}
        </>
      )
    );
  };
